import { render, staticRenderFns } from "./Payment-30.vue?vue&type=template&id=2f35be0f&scoped=true&"
import script from "./Payment-30.vue?vue&type=script&lang=js&"
export * from "./Payment-30.vue?vue&type=script&lang=js&"
import style0 from "./Payment-30.vue?vue&type=style&index=0&id=2f35be0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f35be0f",
  null
  
)

export default component.exports